<template>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="registration-title" v-if="FormInputs.IndividualLabels">Additional Information</div>
        <div class="registration-title" v-if="FormInputs.BusinessLabels">Office Location Information</div>
        <div class="registration-title" v-if="FormInputs.NonProfitLabels">Location Information</div>
        <div class="account_section_box">
            <div class="row">
                <div  class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <p v-if="FormInputs.IndividualLabels">Please enter your shipping information.</p>
                    <p v-if="FormInputs.NonProfitLabels || FormInputs.BusinessLabels">Please enter the following information for your primary location.</p>
                </div>
                <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                    <div class="form-group" v-if="FormInputs.OfficeLocationName && Account.PrimaryContact.IsMultiLocation">
                        <label v-if="FormInputs.BusinessLabels">Office Location Name*</label>
                        <label v-if="FormInputs.NonProfitLabels">Chapter Location Name*</label>
                        <input v-bind:class="{error_field: OfficeLocationValidationResult.OfficeLocationName }" v-model="Account.PrimaryContact.OfficeLocation.Name" type="text" class="form-control">
                        <p class="error-message" v-if="OfficeLocationValidationResult.OfficeLocationName">{{OfficeLocationValidationResult.OfficeLocationName}}</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                    <div class="form-group" v-show="FormInputs.OfficeLocationStreetAddress">
                        <label>Street Address*</label>
                        <input v-bind:class="{error_field: OfficeLocationValidationResult.OfficeLocationStreetAddress }" v-model="Account.PrimaryContact.OfficeLocation.StreetAddress" @change="addressChanged" type="text" class="form-control">
                        <p class="error-message" v-if="OfficeLocationValidationResult.OfficeLocationStreetAddress">{{ OfficeLocationValidationResult.OfficeLocationStreetAddress}}</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div class="form-group" v-show="FormInputs.OfficeLocationSuite">
                        <label>Suite</label>
                        <input v-model="Account.PrimaryContact.OfficeLocation.Suite" type="text" class="form-control">
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div class="form-group" v-show="FormInputs.OfficeLocationCity">
                        <label>City*</label>
                        <input v-bind:class="{ error_field: OfficeLocationValidationResult.OfficeLocationCity }" v-model="Account.PrimaryContact.OfficeLocation.City" type="text" class="form-control">
                        <p class="error-message" v-if="OfficeLocationValidationResult.OfficeLocationCity">{{OfficeLocationValidationResult.OfficeLocationCity}}</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div class="form-group" v-show="FormInputs.OfficeLocationState">
                        <label>State*</label>
                        <select v-bind:class="{ error_field: OfficeLocationValidationResult.OfficeLocationState }" v-model="Account.PrimaryContact.OfficeLocation.State" class="form-control" style="height:36.5px;">
                            <option v-for="(value, key) in State" v-bind:value="value">{{value}}</option>
                        </select>
                        <p class="error-message" v-if="OfficeLocationValidationResult.OfficeLocationState">{{OfficeLocationValidationResult.OfficeLocationState}}</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <div class="form-group" v-show="FormInputs.OfficeLocationZip">
                        <label>Zip Code*</label>
                        <span v-if="IsValidNPI">
                            <i class="fa fa-check-circle check_icon"></i>
                        </span>
                        <span v-if="IsAddressValidating" class="loading_icon">
                            <img src="../../../static/img/loading.gif" style="width: 25px"/>
                        </span>
                        <input v-bind:class="{error_field: OfficeLocationValidationResult.OfficeLocationZip }" v-model="Account.PrimaryContact.OfficeLocation.Zip" type="text" class="form-control" v-on:keypress="IsNumber(this.event)" v-on:blur="ValidateAddress()" maxlength="5">
                        <p class="error-message" v-if="OfficeLocationValidationResult.OfficeLocationZip">{{OfficeLocationValidationResult.OfficeLocationZip}}</p>
                    </div>
                </div>
                <div class="col-lg-6 col-md-9 col-sm-9 col-xs-12">
                    <div class="form-group" v-show="FormInputs.OfficeLocationPhoneNumber">
                        <label>Phone Number<span v-if="Account.PrimaryContact.IsMultiLocation">*</span></label>
                        <div class="row div-phone">
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-4 sm">
                                <input ref="office_number_1" type="text" maxlength="3" v-on:keypress="PhoneNumberCheck(this.event)" v-on:keyup="NextField(1)" v-bind:class="{error_field: OfficeLocationValidationResult.OfficeLocationPhoneNumber }" v-model="Account.PrimaryContact.OfficeLocation.CountryCode" class="form-control">
                            </div>
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-4 sm">
                                <input ref="office_number_2" type="text" maxlength="3" v-on:keypress="PhoneNumberCheck(this.event)" v-on:keyup="NextField(2)" v-bind:class="{error_field: OfficeLocationValidationResult.OfficeLocationPhoneNumber }" v-model="Account.PrimaryContact.OfficeLocation.AreaCode" class="form-control">
                            </div>
                                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 md">
                                <input ref="office_number_3" type="text" maxlength="4" v-on:keypress="PhoneNumberCheck(this.event)" v-bind:class="{error_field: OfficeLocationValidationResult.OfficeLocationPhoneNumber }" v-model="Account.PrimaryContact.OfficeLocation.Phone" class="form-control">
                            </div>
                        </div>
                            <p class="error-message" v-if="OfficeLocationValidationResult.OfficeLocationPhoneNumber">{{OfficeLocationValidationResult.OfficeLocationPhoneNumber}}</p>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="form-group">
                        <label>QR Donation Code
                            <i class="fas fa-question-circle tooltip-icon" style="cursor: pointer;"></i>
                            <span class="tooltiptext">Please enter the combination of letters and numbers exactly as shown below the QR Code on the Champions for Sight® register sign.<br>Make sure there are no spaces or extra characters.</span>
                        </label>
                        <input v-model="Account.PrimaryContact.OfficeLocation.QRDonationCode" type="text" class="form-control">
                    </div>
                </div>
                <!-- Payment Processing Companies -->
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="form-group">
                        <label>What are your current payment processing company?</label>
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" v-for="(option, index) in paymentProcessingOptions" :key="option">
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <input
                                            :value="option"
                                            v-model="Account.PaymentProcessors.List"
                                            class="form-check-input"
                                            type="checkbox"
                                        />
                                        {{ option }}
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 d-flex align-items-center">
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <input
                                            value="Other"
                                            v-model="otherPaymentProcessor"
                                            class="form-check-input"
                                            type="checkbox"
                                        />
                                        Other
                                    </label>
                                </div>
                                <input 
                                    v-if="otherPaymentProcessor"
                                    v-model="Account.PaymentProcessors.Others"
                                    placeholder="Please specify" 
                                    class="form-control mt-2 ml-2" 
                                    type="text" 
                                    style="flex: 1;"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Donation Solutions -->
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="form-group">
                        <label>Which donation solution are you interested in utilizing? (Multi-Select)</label>
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" v-for="(option, index) in donationSolutionOptions" :key="option">
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <input
                                            :value="option"
                                            v-model="Account.DonationSolutions.List"
                                            class="form-check-input"
                                            type="checkbox"
                                        />
                                        {{ option }}
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 d-flex align-items-center">
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <input
                                            value="Other"
                                            v-model="otherDonationSolution"
                                            class="form-check-input"
                                            type="checkbox"
                                        />
                                        Other
                                    </label>
                                </div>
                                <input 
                                    v-if="otherDonationSolution" 
                                    v-model="Account.DonationSolutions.Other" 
                                    placeholder="Please specify" 
                                    class="form-control mt-2 ml-2" 
                                    type="text" 
                                    style="flex: 1;"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" v-if="Account.PrimaryContact.IsMultiLocation">
                    <div class="form-group" v-show="FormInputs.OfficeLocationContactFirstName">
                        <label v-if="FormInputs.BusinessLabels">Office Contact First Name<span v-if="Account.PrimaryContact.IsMultiLocation">*</span></label>
                        <label v-if="FormInputs.NonProfitLabels">Location Contact First Name<span v-if="Account.PrimaryContact.IsMultiLocation">*</span></label>
                        <input v-model="Account.PrimaryContact.OfficeLocation.ContactFirstName" v-bind:class="{error_field: OfficeLocationValidationResult.OfficeLocationContactFirstName }" type="text" class="form-control">
                        <p class="error-message" v-if="OfficeLocationValidationResult.OfficeLocationContactFirstName">{{OfficeLocationValidationResult.OfficeLocationContactFirstName}}</p>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" v-if="Account.PrimaryContact.IsMultiLocation">
                    <div class="form-group" v-show="FormInputs.OfficeLocationContactLastName">
                        <label v-if="FormInputs.BusinessLabels">Office Contact Last Name<span v-if="Account.PrimaryContact.IsMultiLocation">*</span></label>
                        <label v-if="FormInputs.NonProfitLabels">Location Contact Last Name<span v-if="Account.PrimaryContact.IsMultiLocation">*</span></label>
                        <input v-model="Account.PrimaryContact.OfficeLocation.ContactLastName" v-bind:class="{error_field: OfficeLocationValidationResult.OfficeLocationContactLastName }" type="text" class="form-control">
                        <p class="error-message" v-if="OfficeLocationValidationResult.OfficeLocationContactFirstName">{{OfficeLocationValidationResult.OfficeLocationContactLastName}}</p>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" v-if="Account.PrimaryContact.IsMultiLocation">
                    <div class="form-group" v-show="FormInputs.OfficeLocationContactRole">
                        <label v-if="FormInputs.BusinessLabels">Role in Business</label>
                        <label v-if="FormInputs.NonProfitLabels">Role in Organization</label>
                        <select v-model="Account.PrimaryContact.OfficeLocation.ContactRole" class="form-control" style="height: 36.5px;">
                            <option v-for="(value, key) in  (FormInputs.RoleBusiness ? RoleBusiness : RoleNonProfit)" v-bind:value="value">{{key}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"></div>
                <!--<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">-->
                    <!--<div class="form-group g-mb-0" v-show="FormInputs.OfficeLocationNumberOfJobs">-->
                        <!--<label>{{pledge}} <span v-bind:data-balloon="pledgeTooltip" data-balloon-pos="down" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span></label>-->
                    <!--</div >-->
                <!--</div>-->
                <!--<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">-->
                    <!--<div class="form-group" v-show="FormInputs.OfficeLocationNumberOfJobs">-->
                        <!--<input v-bind:class="{ error_field: OfficeLocationValidationResult.OfficeLocationNumberOfJobs }" type="number" -->
                         <!--v-on:keypress="G_NumberCheck(this.event)"-->
                         <!--v-on:keyup="G_NumberInputCheck(Account.PrimaryContact.OfficeLocation)"-->
                         <!--v-model="Account.PrimaryContact.OfficeLocation.NumberOfJobs" class="form-control no-arrow-updown">-->
                        <!--<p class="error-message" v-if="OfficeLocationValidationResult.OfficeLocationNumberOfJobs">{{OfficeLocationValidationResult.OfficeLocationNumberOfJobs}}</p>-->
                    <!--</div>-->
                <!--</div>-->
                <!--<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" v-show="Account.PrimaryContact.OfficeLocation.NumberOfJobs >= 100">-->
                    <!--<p>Due to the high pledge/forecast, please break out your estimate by month across the remainder of the year.</p>-->
                    <!--<p><i><small>If there is a difference, your monthly total will replace your pledged number of orders</small></i></p>-->
                    <!--<div class="table-responsive">-->
                        <!--<table class="table table-bordered table-bg">-->
                            <!--<thead>-->
                                <!--<tr class="text-center">-->
                                    <!--<th scope="col">Jan</th>-->
                                    <!--<th scope="col">Feb</th>-->
                                    <!--<th scope="col">Mar</th>-->
                                    <!--<th scope="col">Apr</th>-->
                                    <!--<th scope="col">May</th>-->
                                    <!--<th scope="col">Jun</th>-->
                                <!--</tr>-->
                            <!--</thead>-->
                            <!--<tbody>-->

                                <!--<tr>-->
                                    <!--<td><input ref="january_input" type="number" min="0" v-on:keyup="TotalJobs()" v-model="Account.PrimaryContact.OfficeLocation.Jobs.January" class="form-control"></td>-->
                                    <!--<td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="Account.PrimaryContact.OfficeLocation.Jobs.February" class="form-control"></td>-->
                                    <!--<td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="Account.PrimaryContact.OfficeLocation.Jobs.March" class="form-control"></td>-->
                                    <!--<td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="Account.PrimaryContact.OfficeLocation.Jobs.April" class="form-control"></td>-->
                                    <!--<td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="Account.PrimaryContact.OfficeLocation.Jobs.May" class="form-control"></td>-->
                                    <!--<td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="Account.PrimaryContact.OfficeLocation.Jobs.June" class="form-control"></td>-->
                                <!--</tr>-->
                            <!--</tbody>-->
                        <!--</table>-->
                        <!--<table class="table table-bordered table-bg">-->
                            <!--<thead>-->
                                <!--<tr class="text-center">-->
                                    <!--<th scope="col">Jul</th>-->
                                    <!--<th scope="col">Aug</th>-->
                                    <!--<th scope="col">Sep</th>-->
                                    <!--<th scope="col">Oct</th>-->
                                    <!--<th scope="col">Nov</th>-->
                                    <!--<th scope="col">Dec</th>-->
                                <!--</tr>-->
                            <!--</thead>-->
                            <!--<tbody>-->
                                <!--<tr>-->
                                    <!---->
                                    <!--<td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="Account.PrimaryContact.OfficeLocation.Jobs.July" class="form-control"></td>-->
                                    <!--<td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="Account.PrimaryContact.OfficeLocation.Jobs.August" class="form-control"></td>-->
                                    <!--<td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="Account.PrimaryContact.OfficeLocation.Jobs.September" class="form-control"></td>-->
                                    <!--<td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="Account.PrimaryContact.OfficeLocation.Jobs.October" class="form-control"></td>-->
                                    <!--<td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="Account.PrimaryContact.OfficeLocation.Jobs.November" class="form-control"></td>-->
                                    <!--<td><input type="number" min="0" v-on:keyup="TotalJobs()" v-model="Account.PrimaryContact.OfficeLocation.Jobs.December" class="form-control"></td>-->
                                <!--</tr>-->
                            <!--</tbody>-->
                        <!--</table>-->
                        <!--<div class="table-bg" style="border: 1px solid #ccc; padding: 10px; ">-->
                            <!--<p style="margin: 0; text-align: right"><b>Total: {{total}}</b></p>-->
                        <!--</div>-->
                    <!--</div>-->
                    <!--<p class="error-message" v-if="OfficeLocationValidationResult.OfficeLocationJobs">{{OfficeLocationValidationResult.OfficeLocationJobs}}</p>-->
                <!--</div>-->
                <!--<pledge :Account="Account"  :PledgeLabel="pledge" :PledgeHelpText="pledgeTooltip" :FormInputs="FormInputs" :OfficeLocationValidationResult="OfficeLocationValidationResult"></pledge>-->
                <!-- <div class="evf-invite col-lg-8 offset-lg-2 col-md-8 offset-md-2 col-sm-12 offset-sm-0 col-xs-8 offset-xs-0" v-if="Account.PrimaryContact.IsMultiLocation">
                    <button class="evf-button" @click="isInviteDoctor = !isInviteDoctor" v-show="FormInputs.OfficeLocationName">{{invite}}</button>
                </div> -->
                <div v-if="isInviteDoctor && Account.PrimaryContact.IsMultiLocation">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <p class="invite_desc" v-if="FormInputs.BusinessLabels">
                            Please enter the following information for other office locations within your business to send them an invite to create a linked portal account.
                        </p>
                        <p class="invite_desc" v-if="FormInputs.NonProfitLabels">
                            Please enter the following information for your other chapter locations within your organization or territory to send them an invite to create a linked portal account.
                        </p>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="form-group">
                            <label class="invite_label" v-if="FormInputs.BusinessLabels">Office Location Name*</label>
                            <label class="invite_label" v-if="FormInputs.NonProfitLabels">Chapter Location Name*</label>
                            <input type="text" class="form-control">
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="form-group">
                            <label class="invite_label">Email Address*</label>
                            <input type="text" class="form-control">
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>
<script>
    import Pledge from "../registration/Pledge"
    export default {
        components: { Pledge },
        props: ['Account', 'OfficeLocationValidationResult', 'FormInputs', 'State', 'RoleNonProfit',
                'RoleBusiness', 'IsValidNPI', 'IsAddressValidating'],
        data(){
            return{
                otherDonationSolution: null,
                otherPaymentProcessor: null,
                isInviteDoctor:false,
                isTooltipVisible: false,
                otherDonationSolution: null,
                otherPaymentProcessor: null,
                paymentProcessingOptions: [
                'Global Payments',
                'Open Edge by Global Payments',
                'Square',
                'Clover',
                'Ciao!',
                // 'Other',
                ],
                donationSolutionOptions: [
                    'Integration Point of Sale Solution',
                    'Charitable SKU (UPC Code)',
                    'QR Code',
                    // 'Other',
                ],
                // total:0
            }
        },
        computed:{
            pledge: function(){
                var text = null;
                if(this.$route.params.type == "Individual"){
                    text = "The participant pledges to place the following number of charitable orders this calendar year.*";
                }
                else if(this.$route.params.type == "Business"){
                    text = "This location of the business pledges/forecasts to place the following number of charitable orders this calendar year.*";
                }
                else if(this.$route.params.type == "NonProfit"){
                    text = "This location of the organization forecasts to place the following number of charitable orders this calendar year.*";
                }
                return text;
            },
            invite: function(){
                var text = null;
                if(this.$route.params.type == "Business"){
                    text = "Invite another location within your business";
                }
                else if(this.$route.params.type == "NonProfit"){
                    text = "Invite another location within your organization";
                }
                return text;
            },
        },
        methods:{
            // TotalJobs(){
            //     this.total = ((this.Account.PrimaryContact.OfficeLocation.Jobs.January ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.January) : 0) +
            //     ((this.Account.PrimaryContact.OfficeLocation.Jobs.February ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.February): 0) +
            //     ((this.Account.PrimaryContact.OfficeLocation.Jobs.March ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.March): 0) +
            //     ((this.Account.PrimaryContact.OfficeLocation.Jobs.April ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.April): 0) +
            //     ((this.Account.PrimaryContact.OfficeLocation.Jobs.May ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.May): 0) +
            //     ((this.Account.PrimaryContact.OfficeLocation.Jobs.June ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.June): 0) +
            //     ((this.Account.PrimaryContact.OfficeLocation.Jobs.July ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.July): 0) +
            //     ((this.Account.PrimaryContact.OfficeLocation.Jobs.August ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.August): 0) +
            //     ((this.Account.PrimaryContact.OfficeLocation.Jobs.September ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.September): 0) +
            //     ((this.Account.PrimaryContact.OfficeLocation.Jobs.October ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.October): 0) +
            //     ((this.Account.PrimaryContact.OfficeLocation.Jobs.November ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.November): 0) +
            //     ((this.Account.PrimaryContact.OfficeLocation.Jobs.December ) ? parseInt(this.Account.PrimaryContact.OfficeLocation.Jobs.December): 0);
            // },
            addressChanged(evt){
                if(!this.Account.PrimaryContact.OfficeLocation.StreetAddress) return
                if(this.checkIfAddressHasPO_BOX(this.Account.PrimaryContact.OfficeLocation.StreetAddress.toString()) == true){
                    alert("Sorry, our labs cannot ship to a PO BOX. Please enter a valid shipping address.")
                }
                // this.Account.PrimaryContact.OfficeLocation.StreetAddress = this.RemovePOBOX(this.Account.PrimaryContact.OfficeLocation.StreetAddress.toString())
            },
            IsNumber(evt){
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();;
                } else {
                    return true;
                }
            },
            PhoneNumberCheck(evt){
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();;
                }
                // else {
                //     this.FocusNextField(this.$refs.office_number_1,this.$refs.office_number_2,this.$refs.office_number_3);
                //     return true;
                // }
            },
            NextField(field){
                var focus1 = this.$refs.office_number_1;
                var focus2 = this.$refs.office_number_2;
                var focus3 = this.$refs.office_number_3;

                if(field == 1 && focus1.value.length == 3){
                    focus2.focus();
                    }
                else if (field == 2 && focus2.value.length == 3){
                    focus3.focus();
                    }
            },
            FocusNextField(element1,element2,element3){
                // To proceed in next field when matched the required number of digits
                if(element1.value.length == 2){
                    element2.focus();
                }
                else if (element2.value.length == 2){
                    element3.focus();
                }
            },
            ValidateAddress() {
                this.$emit("addressCheck");
            }
        },
    }
</script>


// WEBPACK FOOTER //
// OfficeLocationInformation.vue?5ee73b5d